import { de } from '../../lib/i18n/de';

interface SegmentedProgressProps {
  total: number;
  completed: number;
  /** Anzeige-Label rechts neben den Segmenten (default „N / M abgeschlossen") */
  label?: string;
}

/**
 * Editorial-Stil-Progress: dünne Balken-Segmente, ein Segment pro Step,
 * Stone-900 für abgeschlossen, Stone-200 für offen. Adaptiert vom
 * Gründerworkspace-Pattern: gleiche Optik, gleiche tracking-widest-Mikrolabels,
 * aber sprachlich erwachsen-respektvoll („abgeschlossen" statt „erledigt").
 */
export function SegmentedProgress({ total, completed, label }: SegmentedProgressProps) {
  const safeTotal = Math.max(0, total);
  const safeCompleted = Math.max(0, Math.min(safeTotal, completed));
  const computedLabel =
    label ??
    `${safeCompleted} / ${safeTotal} ${
      safeCompleted === 1 ? de.hub.progressLabelSingular : de.hub.progressLabelPlural
    }`;

  return (
    <div
      className="flex items-center gap-2"
      role="progressbar"
      aria-valuemin={0}
      aria-valuemax={safeTotal}
      aria-valuenow={safeCompleted}
      aria-label={computedLabel}
    >
      <div className="flex flex-1 items-center gap-1.5">
        {Array.from({ length: safeTotal }).map((_, i) => (
          <div
            key={i}
            className={`h-2 flex-1 rounded-sm transition-colors duration-500 ${
              i < safeCompleted ? 'bg-stone-900' : 'bg-stone-200'
            }`}
          />
        ))}
      </div>
      <span className="ml-3 whitespace-nowrap font-sans text-xs font-medium uppercase tracking-widest text-stone-500">
        {computedLabel}
      </span>
    </div>
  );
}
